<script>
    import { preventDefault } from 'svelte/legacy';

    import { createEventDispatcher } from 'svelte';
    import tagService from '../service.js';
    import { flatten422Errors} from '../../../services/api.svelte.js';
    import { translateErrorMessages } from '../../../services/api.svelte.js';
    import SearchResults from '../../../components/search-results.svelte';
    import findingService from '../../finding/v2-service.js';
    import vulnerabilityService from '../../vulnerability/service.js';
    import AssetsApi from '../../asset/assets.api.js';
    import { format } from 'svelte-i18n';

    const dispatch = createEventDispatcher();

    let {
        tag,
        findings = [],
        assets = [],
        vulnerabilities = [],
        parent
    } = $props();

    let formData = $state({});
    let formDataPromise;
    let formIsSubmitted = false;
    // API string errors
    let APIerror = null;
    let tagRegexError = null;
    // API 422 errors
    let formApiErrors = {};
    let findings_are_loading = $state(false);
    let search_results = $state();
    let search_result = $state("");
    let showDropdown = $state(false);
    let has_searched_once = false;
    let findingsToAssociate = $state([]);
    let findingsToRemove    = [];
    let findingsAssociated  = $state([]);
    let is_edit;

    // add form
    if (!tag) {
        formDataPromise = Promise.resolve({});
        is_edit = false;
    }
    // edit form
    else {
        formData = {
            name: tag.name,
        };
        is_edit = true;
        if(!tag.findings && tag.finding){
            findingsAssociated = typeof tag.finding === 'string' ? JSON.parse(tag.finding) : tag.finding;
        }
        else if(tag.findings && !tag.finding) {
            findingsAssociated = JSON.parse(tag.findings);
        }
        else {
            findingsAssociated = [];
        }
    }

    function containsUppercase(str) {
        return /[A-Z]/.test(str);
    }

    function handleSubmit() {
        formIsSubmitted = true;
        // reset API errors
        formApiErrors = {};

        if(containsUppercase(formData.name)) return tagRegexError = 'Se han utilizado caracteres inválidos. Por favor, cargue las etiquetas utilizando solamente números, letras minúsculas o guiones medios (-)';

        tagService.save(formData, [])
            .then(async savedTag => {
                if(findingsToAssociate.length > 0){
                    for(let finding of findingsToAssociate){
                        let reqData = {
                            tag_id: savedTag.id,
                            target_object_type: "Finding",
                            target_object_id: finding.id
                        }
                        await tagService.saveAssociation(reqData, [], {});
                    }
                    formData = {};
                    formIsSubmitted = false;
                    formApiErrors = {}
                }

                dispatch("save", {savedTag});
                //clear formData and form status and errors
                // when modal is closed after sending add request
                formData = {};
                formIsSubmitted = false;
                formApiErrors = {}
                return true;
            })
            .catch(errors => {
                if(typeof(errors.detail) == 'string'){
                   APIerror = translateErrorMessages(errors.detail, "Etiquetas");
                }
                else {
                    // parse API errors
                    formApiErrors = flatten422Errors(errors);
                }

                return false;
            })
        ;
    }

    const handleSearch = (e) =>{
        showDropdown = true;
        search_results = findings;
        let searchValue = e.target.value;
        search_results = search_results.filter(sr=> sr.name ? sr.name.includes(searchValue) : sr.nickname.includes(searchValue));
        search_results = search_results;
    }

    const containsObject = (obj, list) => {
        var i;
        for (i = 0; i < list.length; i++) {
            if (list[i].id === obj.id) {
                return true;
            }
        }
        return false;
    }

    const selectFinding = (e) =>{
        let finding = e.detail;
        formData.finding_id = finding.id;
        //showDropdown = false;
        search_result = finding.name;

        if(!containsObject(finding, findingsToAssociate)){
            findingsToAssociate.push(finding);
        }
        findingsToAssociate = findingsToAssociate;
        //findings = findings.filter(item=> item.id != finding.id);
        //@TODO: remove/mark selected findings on search panel
    }

    const removeFindingToAssociate = (i, )=>{
        findingsToRemove.push(findingsToAssociate[i]);
        findingsToAssociate.splice(i, 1);
        findingsToAssociate = findingsToAssociate;
    }

    const handleFindingInput = async () =>{
        findings_are_loading = true;
        if(!findings.length) findings = await findingService.search("v2/finding/", {})
        if(!vulnerabilities.length) vulnerabilities = await vulnerabilityService.search("v2/vulnerability/", {})
        if(!assets.length) assets = await AssetsApi.fetchAssets("v2/asset/", {})

        for(let fnd of findings){
            let asset         = assets.find(asset=>asset.id === fnd.asset_id);
            let vulnerability = vulnerabilities.find(vul=> vul.id === fnd.vulnerability_id);
            if(!vulnerability) vulnerability = await vulnerabilityService.find("v2/vulnerability", fnd.vulnerability_id)
            fnd.vulnerability = vulnerability.title_es || vulnerability.title;
            fnd.priority      = vulnerability.priority;
            fnd.level         = vulnerability.level;
            fnd.asset         = asset;
            fnd.name          = vulnerability && asset ? (vulnerability.title_es || vulnerability.title) + ' - ' + asset.name : '';
            fnd.asset_name    = asset ? asset.name : "";
        }
        showDropdown = true;
        findings = findings;
        search_results = findings;
        has_searched_once = true;
        findings_are_loading = false;
    }

    handleFindingInput();
</script>
<style>

    .search-elements-btn{
        color: #0000003d;
    }

</style>

<form role="form" novalidate onsubmit={preventDefault(handleSubmit)}>
    <div class="card">
        <div class="card-body" style="position: relative;">
            {#if tag}
                <div class="mb-3">
                    <label for="name">{$format("form.fields.name")}<span  class="text-danger">*</span></label>
                    <span class="d-block">{tag.name}</span>
                </div>
            {/if}
            <div class="mb-3">
                <div>
                    <span>{$format("page.tag.search_finding")} </span>
                    <span style="position: relative;">
                        {#if findings_are_loading}
                            <i class="fa fa-spin fa-sync-alt"></i>
                        {:else}
                            <input class="form-control" type="text" oninput={handleSearch} placeholder="Buscar..." bind:value={search_result} style="text-indent: 20px;"/>
                            {#if !showDropdown}<span onclick={handleFindingInput} style="font-size: 10px; text-decoration: underline; cursor: pointer;">Ver todos los hallazgos</span>{/if}
                            <i class="fas fa-search search-elements-btn" style="cursor: pointer; position: absolute; left: 5px; top: 2px;"></i>
                        {/if}
                    </span>
                    <SearchResults elements={search_results} {showDropdown} element_being_selected={"hallazgo"} on:selectElement={selectFinding} on:closeSearchPanel={()=>showDropdown = false} />
                </div>
                <select id="tagFormFinding" class="form-control d-none" bind:value={formData.finding_id} style="max-width: 318px; margin-top: 1em;">
                    <option value="none">{$format("form.fields.select")}...</option>
                    {#if !findings_are_loading}
                        {#each findings as finding}
                            <option value={finding.id}>{finding.nickname || finding.name}</option>
                        {/each}
                    {/if}
                </select>
            </div>
            {#if !parent || parent != 'detail'}
                <label for="associatedFindings">{$format("page.tag.associated_findings")}:</label>
                {#if findingsAssociated.length}
                    {#each findingsAssociated as finding, i}
                        <div>{finding.name || ""}</div>
                    {/each}
                {:else}
                    <div>{$format("results_not_found")}</div>
                {/if}
            {/if}
            {#if findingsToAssociate.length > 0}
            <label for="findingsToAssociate" class="mt-3">{$format("page.tag.findings_to_associate")}:</label>
                {#each findingsToAssociate as finding, i}
                    <div>{finding.nickname || finding.name}<i class="fas fa-times btnDeleteFinding float-end" onclick={()=>removeFindingToAssociate(i, findingsToAssociate)}></i></div>
                {/each}
            {/if}
        </div>
        <div class="card-footer">
            <button type="submit" class="btn btn-primary t-submit-tag-btn">{$format("buttons.save")}</button>
            <button type="button" class="btn btn-default" data-bs-dismiss="modal">{$format("buttons.cancel")}</button>
        </div>

    </div>
</form>
